module.exports = __webpack_public_path__ + "img/2.a8c8f99b.jpg";